'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gsap = require('gsap');

var _bodyScrollLock = require('body-scroll-lock');

exports.default = {
  init: function init() {
    var toggleOpen = document.querySelector('.site-header-toggle--open');
    var toggleClose = document.querySelector('.site-header-toggle--close');
    var overlay = document.querySelector('.site-overlay');
    var overlayMenu = document.querySelector('.site-overlay-menu');
    var animation = this.overlayAnimation();

    if (toggleOpen) {
      toggleOpen.addEventListener('click', function () {
        animation.play();
        (0, _bodyScrollLock.disableBodyScroll)(overlayMenu);
      });

      toggleOpen.addEventListener('mouseenter', function () {
        var img = overlay.querySelector('.site-overlay-img');

        if (img && typeof img.dataset.src !== 'undefined' && img.dataset.src && img.src == '') {
          img.src = img.dataset.src;
        }
      });
    }

    if (toggleClose) {
      toggleClose.addEventListener('click', function () {
        animation.reverse();
        overlay.classList.remove('open');
        (0, _bodyScrollLock.enableBodyScroll)(overlayMenu);
      });
    }
  },
  overlayAnimation: function overlayAnimation() {
    var overlay = document.querySelector('.site-overlay');
    var tl = _gsap.gsap.timeline({
      paused: true,
      defaults: { ease: 'power1.inOut' },
      onComplete: function onComplete() {
        overlay.classList.add('open');
      }
    });

    if (overlay) {
      var mediaContainer = overlay.querySelector('.site-overlay-media');
      var navContainer = overlay.querySelector('.site-overlay-nav');

      if (window.matchMedia('(min-width: 641px)').matches) {
        tl.to(mediaContainer, { duration: 0.5, left: 0 });
        tl.to(navContainer, { duration: 0.55, right: 0 }, 0);
      } else {
        tl.to(navContainer, { duration: 0.3, opacity: 1, visibility: 'visible' });
      }
    }

    return tl;
  }
};


// WEBPACK FOOTER //
// ./scripts/components/overlayMenu.js